module.exports = __webpack_public_path__ + "static/media/school.30ee57fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/school.svg
// module id = 649
// module chunks = 36